<script>
  import ChatWithSupportLink from "@shared/svelte/Components/ChatWithSupportLink.svelte";
</script>

<div class="fizz-styles">
  <div class="grid-row align-center fizz-inset-vertical-48">
    <div class="grid-col c12-12">
      <div class="secondary-body--regular">Questions or feedback?</div>
      <ChatWithSupportLink message={"Chat with Support"} brandprimary={true} />
    </div>
  </div>
</div>
